
const mapping ={
    'robot':'机器人',
    'sv':'伺服系统',
    'inv':'变频器',
}

export const getTitle = (pathname)=>{
    if(pathname==='/robot'||pathname==='robot'){
        return '机器人'
      }else if(pathname==='/sv'||pathname==='sv'){
        return '伺服系统'
      }else if(pathname==='/inv'||pathname==='inv'){
        return '变频器'
      }else if(pathname==='/plc'||pathname==='plc'){
        return '可编程控制器'
      }else if(pathname==='/lv'||pathname==='lv'){
        return '低压配电系统'
      }else if(pathname==='/got'||pathname==='got'){
        return '人机界面'
      }else if(pathname==='/edm'||pathname==='edm'){
        return '放电加工机'
      }else if(pathname==='/lm'||pathname==='lm'){
        return '激光加工机'
      }
}

export const getTitleById =(identification)=>{
    if(identification==='robot'){
        return '机器人'
      }else if(identification==='sv'){
        return '伺服'
      }else if(identification==='inv'){
        return '变频器'
      }else if(identification==='plc'){
        return '可编程控制器'
      }else if(identification==='lv'){
        return '低压配电'
      }else if(identification==='got'){
        return '人机界面'
      }else if(identification==='edm'){
        return '放电加工机'
      }else if(identification==='lm'){
        return '激光加工机'
      }
}
export const getIdentification = (pathname)=>{
    if(pathname==='/robot'){
        return 'robot'
      }else if(pathname==='/sv'){
        return 'sv'
      }else if(pathname==='/inv'){
        return 'inv'
      }else if(pathname==='/plc'){
        return 'plc'
      }else if(pathname==='/lv'){
        return 'lv'
      }else if(pathname==='/got'){
        return 'got'
      }else if(pathname==='/edm'){
        return 'edm'
      }else if(pathname==='/lm'){
        return 'lm'
      }
}
export default mapping;